import { MINUTE_IN_MS } from "@shared/time-constants";

export namespace Constants {
  export const BRAND_INFO_STORAGE_KEY = "brand-info";
  export const PUBLIC_JWT_STORAGE_KEY = "public-jwt";
  export const JWT_STORAGE_KEY = "jwt";
  export const PATIENT_ACTIONS_SESSION_STORAGE_KEY = "patient-actions";
  export const PATIENT_ACTION_COMPLETED_SESSION_STORAGE_KEY = "patient-action-completed";
  export const PATIENT_ACTION_COMPLETED_SESSION_EXPIRY = 5 * MINUTE_IN_MS;
  export const RESTRICTED_SITE_STORAGE_KEY = "restricted-site";
  export const MAX_PATIENT_AGE = 120;
  export const MAX_MEDICAL_HISTORY_DETAILS_LENGTH = 2000;

  class Route {
    private _segments: Array<string>;

    constructor(private _path: string) {
      this._segments = this._path.split("/");
    }

    public get last(): string {
      return this._segments[this._segments.length - 1];
    }

    public get full(): string {
      return this._path;
    }

    public get path(): string {
      return `/${this._path}`;
    }
  }

  export namespace ROUTES {
    export const UPDATE_MEDICAL_HISTORY = new Route("medical-history/update-medical-history");
  }
}
